import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class SpecialtiesService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http
      .get(environment.apiUrl + 'admin/specialties', httpOptions)
      .pipe(map((result) => result));
  }

  create(data: any) {
    return this.http
    .post(environment.apiUrl + 'admin/specialties', data)
    .pipe(map((result) => result));
  }

  delete(id: string) {
    return this.http
    .delete(environment.apiUrl + `admin/specialties/${id}`)
    .pipe(map((result) => result));
  }
}
